import { Button, Group, Popover, useMantineTheme } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import React, { useState } from 'react';

const TimeSelector = ({ selectedRange, selectedColor = 'secondaryPurple', data, setSelectedRange, range, setRange }) => {

	// State and hooks
	const [opened, setOpened] = useState(false);
	const theme = useMantineTheme();
	//TODO restart when applied so when it changes it can reload the dates (period/ranges)

	return (
		<Group spacing={4}>
			{/* Total */}
			<Button
				variant="light"
				size="xs"
				compact
				color={selectedRange === 'total' ? selectedColor : 'blueGray'}
				onClick={() => setSelectedRange('total')}
				disabled={data === null}
			>
				Total
			</Button>
			{/* 30 Days */}
			<Button
				variant="light"
				size="xs"
				compact
				color={selectedRange === '30d' ? selectedColor : 'blueGray'}
				onClick={() => setSelectedRange('30d')}
				disabled={data === null}
			>
				30 días
			</Button>
			{/* 7 Days */}
			<Button
				variant="light"
				size="xs"
				compact
				color={selectedRange === '7d' ? selectedColor : 'blueGray'}
				onClick={() => setSelectedRange('7d')}
				disabled={data === null}
			>
				7 días
			</Button>
			{/* Range Selector */}
			<Popover
				opened={opened}
				onChange={setOpened}
				withinPortal
				withArrow
				shadow="sm"
			>
				{/* Opener */}
				<Popover.Target>
					<Button
						variant="outline"
						size="xs"
						compact
						color={selectedRange === 'custom' ? selectedColor : 'blueGray'}
						rightIcon={<IconCalendar stroke={2} size={14} />}
						disabled={data === null}
						onClick={() => setOpened((o) => !o)}
					>
						Período
					</Button>
				</Popover.Target>
				{/* Content */}
				<Popover.Dropdown>
					{/* Date Picker */}
					<DatePicker
						type="range"
						value={range}
						onChange={setRange}
						allowSingleDateInRange
						size="xs"
						styles={{
							day: {
								'&[data-selected], &[data-selected]:hover': {
									backgroundColor: theme.colors.blueGray,
									color: 'white',
								},
								'&[data-in-range], &[data-in-range]:hover': {
									backgroundColor: theme.colors.blueGray,
									color: 'white',
									opacity: 0.5,
								},
								'&[data-first-in-range], &[data-first-in-range]:hover': {
									backgroundColor: theme.colors.blueGray,
									color: 'white',
									opacity: 1,
								},
								'&[data-last-in-range], &[data-last-in-range]:hover': {
									backgroundColor: theme.colors.blueGray,
									color: 'white',
									opacity: 1,
								},
							},
						}}
					/>
					{/* Apply */}
					<Button
						size="xs"
						fullWidth
						mt={8}
						onClick={() => {
							// Set option
							setSelectedRange(null);
							setSelectedRange('custom');
							// Close
							setOpened(false);
						}}
						disabled={!range[0] || !range[1]}
					>
						Aplicar
					</Button>
				</Popover.Dropdown>
			</Popover>
		</Group>
	);

}

export default TimeSelector;
